/**
 * Code Generator — barrel export
 *
 * Provides a convenience API so the rest of the GUI can do:
 *   import {generateCode} from '../lib/code-generator';
 */

import ArduinoGenerator from './arduino-generator';
import PythonGenerator from './python-generator';

const arduinoGenerator = new ArduinoGenerator();
const pythonGenerator = new PythonGenerator();

/**
 * Generate target-language source code from the current VM state.
 *
 * @param {object} vm    scratch-vm instance
 * @param {'arduino'|'micropython'} language
 * @returns {string}     source code
 */
const generateCode = (vm, language = 'arduino') => {
    switch (language) {
    case 'arduino':
        return arduinoGenerator.generate(vm);
    case 'micropython':
        return pythonGenerator.generate(vm);
    default:
        throw new Error(`Unsupported language: ${language}`);
    }
};

export {
    generateCode,
    ArduinoGenerator,
    PythonGenerator
};
